import { RMTMeans, RMTMode } from '@/app/factory-database/src/enums/rmt';

export enum WasteOperationEmissionType {
  SEWERAGE = 'sewerage',
  NON_HAZARDOUS_WASTE = 'nonHazardousWaste',
  WASTE_TREATMENT_DISPOSAL = 'wasteTreatmentDisposal',
  TREATMENT_DISPOSAL_NON_HAZARDOUS_WASTE = 'treatmentDisposalNonHazardousWaste',
  TREATMENT_DISPOSAL_HAZARDOUS_WASTE = 'treatmentDisposalHazardousWaste',
  MATERIALS_RECOVERY = 'materialsRecovery',
  WASTE_TRANSPORTATION = 'wasteTransportation',
  OTHER = 'other',
}

export enum WasteOperationOptionsOther {
  OT_OT = 'OT_OT',
}

export enum WasteOperationOptionsOtherOther {
  OT_OT_OT = 'OT_OT_OT',
}

export enum WastewaterTypeOptions {
  WWT_1 = 'WWT_1',
  WWT_2 = 'WWT_2',
  WWT_3 = 'WWT_3',
  WWT_OT = 'WWT_OT',
}

export enum DischargeAreaOptions {
  DA_1 = 'DA_1',
  DA_2 = 'DA_2',
  DA_OT = 'DA_OT',
}

export enum WasteTypeForCollectionOptions {
  WT_C_1 = 'WT_C_1',
  WT_C_2 = 'WT_C_2',
  WT_C_3 = 'WT_C_3',
  WT_C_4 = 'WT_C_4',
  WT_C_5 = 'WT_C_5',
  WT_C_OT = 'WT_C_OT',
}

export enum WasteClassificationOptions {
  WC_1 = 'WC_1',
  WC_2 = 'WC_2',
  WC_OT = 'WC_OT',
}

export enum TreatmentAndDisposalMethodOptions {
  T_DM_1 = 'T_DM_1',
  T_DM_2 = 'T_DM_2',
  T_DM_3 = 'T_DM_3',
  T_DM_4 = 'T_DM_4',
  T_DM_5 = 'T_DM_5',
  T_DM_6 = 'T_DM_6',
  T_DM_OT = 'T_DM_OT',
}

export enum WasteTypeForTreatmentAndDisposalMethodOptions {
  WT_T_DM_1 = 'WT_T_DM_1',
  WT_T_DM_2 = 'WT_T_DM_2',
  WT_T_DM_3 = 'WT_T_DM_3',
  WT_T_DM_4 = 'WT_T_DM_4',
  WT_T_DM_5 = 'WT_T_DM_5',
  WT_T_DM_6 = 'WT_T_DM_6',
  WT_T_DM_7 = 'WT_T_DM_7',
  WT_T_DM_8 = 'WT_T_DM_8',
  WT_T_DM_9 = 'WT_T_DM_9',
  WT_T_DM_10 = 'WT_T_DM_10',
  WT_T_DM_11 = 'WT_T_DM_11',
  WT_T_DM_OT = 'WT_T_DM_OT',
}

export enum TreatmentAndDisposalMethodForNonHazardousOptions {
  T_DM_NH_1 = 'T_DM_NH_1',
  T_DM_NH_2 = 'T_DM_NH_2',
  T_DM_NH_3 = 'T_DM_NH_3',
  T_DM_NH_4 = 'T_DM_NH_4',
  T_DM_NH_5 = 'T_DM_NH_5',
  T_DM_NH_6 = 'T_DM_NH_6',
  T_DM_NH_7 = 'T_DM_NH_7',
  T_DM_NH_OT = 'T_DM_NH_OT',
}

export enum WasteTypeForHazardousOptions {
  WT_H_1 = 'WT_H_1',
  WT_H_2 = 'WT_H_2',
  WT_H_3 = 'WT_H_3',
  WT_H_4 = 'WT_H_4',
  WT_H_5 = 'WT_H_5',
  WT_H_OT = 'WT_H_OT',
}

export enum TreatmentAndDisposalMethodForHazardousOptions {
  T_DM_H_1 = 'T_DM_H_1',
  T_DM_H_2 = 'T_DM_H_2',
  T_DM_H_3 = 'T_DM_H_3',
  T_DM_H_4 = 'T_DM_H_4',
  T_DM_H_OT = 'T_DM_H_OT',
}

export enum WasteTypeForMaterialsRecoveryOptions {
  WT_MR_1 = 'WT_MR_1',
  WT_MR_2 = 'WT_MR_2',
  WT_MR_3 = 'WT_MR_3',
  WT_MR_4 = 'WT_MR_4',
  WT_MR_5 = 'WT_MR_5',
  WT_MR_6 = 'WT_MR_6',
  WT_MR_7 = 'WT_MR_7',
  WT_MR_8 = 'WT_MR_8',
  WT_MR_9 = 'WT_MR_9',
  WT_MR_10 = 'WT_MR_10',
  WT_MR_11 = 'WT_MR_11',
  WT_MR_OT = 'WT_MR_OT',
}

export type EmissionTypeOneOptionsType =
  | WastewaterTypeOptions
  | WasteTypeForCollectionOptions
  | TreatmentAndDisposalMethodOptions
  | WasteTypeForTreatmentAndDisposalMethodOptions
  | WasteTypeForHazardousOptions
  | WasteTypeForMaterialsRecoveryOptions
  | WasteOperationOptionsOther
  | RMTMode;

export const EmissionTypeOneOptions = [
  ...Object.values(WastewaterTypeOptions),
  ...Object.values(WasteTypeForCollectionOptions),
  ...Object.values(TreatmentAndDisposalMethodOptions),
  ...Object.values(WasteTypeForTreatmentAndDisposalMethodOptions),
  ...Object.values(WasteTypeForHazardousOptions),
  ...Object.values(WasteTypeForMaterialsRecoveryOptions),
  ...Object.values(WasteOperationOptionsOther),
];

export type EmissionTypeTwoOptionsType =
  | DischargeAreaOptions
  | WasteClassificationOptions
  | TreatmentAndDisposalMethodForNonHazardousOptions
  | TreatmentAndDisposalMethodForHazardousOptions
  | RMTMeans
  | WasteOperationOptionsOtherOther;

export const EmissionTypeTwoOptions = [
  ...Object.values(DischargeAreaOptions),
  ...Object.values(WasteClassificationOptions),
  ...Object.values(TreatmentAndDisposalMethodForNonHazardousOptions),
  ...Object.values(TreatmentAndDisposalMethodForHazardousOptions),
  ...Object.values(WasteOperationOptionsOtherOther),
];

export const EMISSION_TYPE_ONE_OTHER_OPTIONS = [
  WastewaterTypeOptions.WWT_OT,
  WasteTypeForCollectionOptions.WT_C_OT,
  TreatmentAndDisposalMethodOptions.T_DM_OT,
  WasteTypeForTreatmentAndDisposalMethodOptions.WT_T_DM_OT,
  WasteTypeForHazardousOptions.WT_H_OT,
  WasteTypeForMaterialsRecoveryOptions.WT_MR_OT,
  WasteOperationOptionsOther.OT_OT,
];

export const EMISSION_TYPE_TWO_OTHER_OPTIONS = [
  DischargeAreaOptions.DA_OT,
  WasteClassificationOptions.WC_OT,
  TreatmentAndDisposalMethodForNonHazardousOptions.T_DM_NH_OT,
  TreatmentAndDisposalMethodForHazardousOptions.T_DM_H_OT,
  WasteOperationOptionsOtherOther.OT_OT_OT,
];
